import { RouteName, TextKey } from '@mews-commander/enums';
import { UnicodeEntity } from '@mews/enums';
import { useLocalizeText } from '@mews/framework';
import { AssistantNavigation } from './AssistantNavigation';
import { useNavigationSearchResult } from './useNavigationSearchResult';
import { useNavigationPath } from './useNavigationPath';

export const useOnboardingAuditNavigation = (): AssistantNavigation[] => {
    const localizeText = useLocalizeText();
    const parentPath = `${localizeText({ textKey: TextKey.Enterprise })}${UnicodeEntity.Space}${
        UnicodeEntity.ForwardSlash
    }${UnicodeEntity.Space}`;

    const dashboard = useNavigationSearchResult(
        RouteName.GoLiveAuditsSetup,
        TextKey.OnboardingSystemAuditDashboard,
        {},
        useNavigationPath(parentPath, TextKey.OnboardingSystemAuditDashboard)
    );

    return [dashboard];
};
